export const REDUCER_KEY_RS_SLIDABLE_PAGINATED = 'rsSlidablePaginated';
export const SLIDABLE_PAGINATED_SET_LOAD_ITEMS = 'rs/SLIDABLE_PAGINATED_SET_LOAD_ITEMS';
export const SLIDABLE_PAGINATED_RELOAD = 'rs/SLIDABLE_PAGINATED_RELOAD';
export const SLIDABLE_PAGINATED_CLEAN_STATE = 'rs/SLIDABLE_PAGINATED_CLEAN_STATE';
export const SLIDABLE_PAGINATED_SET_LOAD_ITEMS_SUCCESS = 'rs/SLIDABLE_PAGINATED_SET_LOAD_ITEMS_SUCCESS';
export const SLIDABLE_PAGINATED_SET_LOAD_ITEMS_FAILURE = 'rs/SLIDABLE_PAGINATED_SET_LOAD_ITEMS_FAILURE';
